import React, { useState } from "react";

// import shape from "../../assets/img/home_4/team_masking.svg";
import {
  IAboutBotData,
  IAboutExOfficioMembersData,
  IBotDescriptionData,
} from "../../exports/interfaces";
import { Link } from "react-router-dom";
import { PdfViwer } from "../PdfViwer";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";
// import { stripHtml } from "../../exports/functions";

export const Trustees = (props: {
  aboutBot: IAboutBotData[];
  aboutExOfficioMembers: IAboutExOfficioMembersData[];
  botDescription: IBotDescriptionData[];
}) => {
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");

  const isMobile = useMobile();
  const isTab = useTab();

  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  const closeViewer = () => setOpenPdf(false);
  return (
    <>
      <section id="board-of-trustees">
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <h2 className="td_section_title td_fs_48 mb-0">
              Board of Trustees
            </h2>
            <div className="td_height_30 td_height_lg_30" />
          </div>
          <div className="row td_gap_y_0">
            <p className="mb-0 td_fs_18 custom-text-p">
              <p>
                <span
                  dangerouslySetInnerHTML={{
                    __html: props.botDescription[0]?.description,
                  }}
                />{" "}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openViewer(
                      props.botDescription[0]?.act_policy_file[0].media.url,
                    );
                  }}
                  className={`td_btn td_style_1 td_radius_10 td_medium custom-td_style_1 ${isMobile || isTab ? "mt-2" : ""}`}
                >
                  <span className="td_btn_in custom_td_btn_in act_btn">
                    <i className="fa fa-file-text"></i>
                    <span>Act & Policy</span>
                  </span>
                </Link>{" "}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openViewer(
                      props.botDescription[0]?.rules_regulations_file[0].media
                        .url,
                    );
                  }}
                  className={`td_btn td_style_1 td_radius_10 td_medium custom-td_style_1  ${isMobile || isTab ? "mt-2" : ""}`}
                >
                  <span className="td_btn_in custom_td_btn_in act_btn">
                    <i className="fa fa-file-text"></i>
                    <span>Rules & Regulations</span>
                  </span>
                </Link>
              </p>
            </p>
            <div className="td_height_30 td_height_lg_30" />
          </div>
          <div className="row td_gap_y_30">
            {props?.aboutBot?.map((member, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                <Item
                  src={`${process.env.REACT_APP_cmsUrl}${member?.image[0]?.media?.url}`}
                  name={member?.name}
                  title={member?.title}
                  sub_title={member?.sub_title}
                />
              </div>
            ))}
          </div>

          <div className="td_height_30 td_height_lg_30" />

          <div className="row td_gap_y_0">
            <p className="td_fs_18">
              <h2 className="td_section_title td_fs_24 mb-2">
                Ex-officio Members of the BoT
              </h2>
              {props?.aboutExOfficioMembers?.map((item) => {
                return (
                  <ul style={{ display: "flex", marginBottom: "5px" }}>
                    <li style={{ flex: 1 }}>{item?.title}</li>
                    <li style={{ flex: 1 }}>{item?.position}</li>
                  </ul>
                );
              })}
            </p>
          </div>
        </div>

        <div className="td_height_30 td_height_lg_40" />
      </section>
      <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
    </>
  );
};

const Item = ({
  src,
  name,
  title,
  sub_title,
}: {
  src: string;
  name: string;
  title: string;
  sub_title: string;
}) => {
  return (
    <div className="td_team td_style_3 text-center position-relative">
      {/* <div className="td_team_thumb_wrap td_mb_20"> */}
      {/* <div className="td_team_thumb"> */}
      <img
        src={src}
        alt=""
        className="td_mb_20"
        style={{
          width: "128px",
          height: "128px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      {/* </div> */}
      {/* <img src={shape} className="td_team_thumb_shape" alt="" /> */}
      {/* </div> */}

      <div className="td_team_info td_white_bg td_mb_30">
        <h3 className="td_team_member_title td_fs_20 td_semibold td_mb_5">
          {name}
        </h3>
        <div style={{ padding: "0px 20px", marginBottom: "5px" }}>{title}</div>
        <div style={{ padding: "0px 20px", color: "gray" }}>{sub_title}</div>
      </div>
    </div>
  );
};
